import { Formik, Form } from 'formik'

import { depositFormFields } from '../cryptoPaymentConstants'
import { CryptoPaymentDepositFormContent } from './CryptoPaymentDepositFormContent'
import { useCryptoPaymentModal } from '../CryptoPaymentModalProvider'
import { formatCurrencyAmount } from '../../../services/utils'
import { useCasinoStore } from '../../../services/store'

export const CryptoPaymentDepositForm = () => {
  const casinoStore = useCasinoStore()
  const casinoCoinsToFiatRate = casinoStore.use.casinoCoinsToFiatRate()

  const { cryptoPaymentModalPackageAmount } = useCryptoPaymentModal()

  const initialValues = {
    [depositFormFields.coinsAmount]: cryptoPaymentModalPackageAmount && casinoCoinsToFiatRate.toCoins.GC
      ? formatCurrencyAmount(cryptoPaymentModalPackageAmount * casinoCoinsToFiatRate.toCoins.GC, 'GC')
      : '',
    [depositFormFields.cryptoAmount]: '',
    [depositFormFields.cryptoCurrencyCode]: '',
    [depositFormFields.address]: '',
    [depositFormFields.destinationTag]: ''
  }

  return (
    <Formik initialValues={initialValues} onSubmit={() => {}}>
      <Form>
        <CryptoPaymentDepositFormContent />
      </Form>
    </Formik>
  )
}
